import React, { useState, useRef, useEffect } from 'react';

const BASE = '/';
const apiFetch = (path, body) => fetch(BASE + path, {
  method: 'POST',
  headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
  body: JSON.stringify(body),
}).then(r => r.json());

const Assistente = () => {
  const [mensagens, setMensagens] = useState([
    { role: 'assistant', content: 'Olá, Vagner! Sou a Clau 🚀 — posso criar tarefas, marcar como realizadas, agendar mensagens WhatsApp, consultar processos no INPI, pesquisar marcas e muito mais, tudo pelo chat. O que vamos fazer hoje?' }
  ]);
  const [input, setInput] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [progresso, setProgresso] = useState('');
  const fimRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    fimRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [mensagens, progresso]);

  const enviar = async (texto) => {
    const msg = (texto || input).trim();
    if (!msg || carregando) return;
    setInput('');
    setMensagens(prev => [...prev, { role: 'user', content: msg }]);
    setCarregando(true);
    setProgresso('');
    try {
      const resp = await fetch(BASE + 'assistente/chat-stream', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` },
        body: JSON.stringify({ mensagem: msg }),
      });

      if (!resp.ok || !resp.body) throw new Error('sem stream');

      const reader = resp.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';
      let respondido = false;

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        buffer += decoder.decode(value, { stream: true });
        const linhas = buffer.split('\n');
        buffer = linhas.pop() || ''; // guarda a linha incompleta
        for (const linha of linhas) {
          if (!linha.trim()) continue;
          let ev;
          try { ev = JSON.parse(linha); } catch { continue; }
          if (ev.tipo === 'progresso') {
            setProgresso(ev.texto);
          } else if (ev.tipo === 'resposta') {
            setMensagens(prev => [...prev, { role: 'assistant', content: ev.texto }]);
            respondido = true;
          } else if (ev.tipo === 'erro') {
            setMensagens(prev => [...prev, { role: 'assistant', content: ev.texto }]);
            respondido = true;
          }
        }
      }
      if (!respondido) {
        setMensagens(prev => [...prev, { role: 'assistant', content: 'Não recebi resposta. Tente novamente.' }]);
      }
    } catch (e) {
      // Fallback: endpoint sem streaming
      try {
        const data = await apiFetch('assistente/chat', { mensagem: msg });
        setMensagens(prev => [...prev, { role: 'assistant', content: data.resposta }]);
      } catch {
        setMensagens(prev => [...prev, { role: 'assistant', content: 'Erro ao conectar com a assistente. Tente novamente.' }]);
      }
    } finally {
      setCarregando(false);
      setProgresso('');
      setTimeout(() => inputRef.current?.focus(), 100);
    }
  };

  const limpar = async () => {
    await apiFetch('assistente/limpar', {});
    setMensagens([{ role: 'assistant', content: 'Conversa reiniciada. Como posso ajudar?' }]);
  };

  const sugestoes = [
    'Me dá um briefing do dia',
    'Quais oportunidades estão paradas há mais de 7 dias?',
    'Cria tarefa: ligar para [cliente] amanhã às 10h',
    'Pesquisa a marca NOVABRAND no INPI',
    'Me fala tudo sobre o cliente [nome]',
    'Consulta o processo 912345678 no INPI',
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 60px)' }}>
      {/* Header */}
      <div style={{ background: '#0a1628', color: '#fff', padding: '8px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 30, height: 30, borderRadius: '50%', background: 'linear-gradient(135deg,#3b82f6,#8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>✨</div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 13 }}>Clau</div>
            <div style={{ fontSize: 10, opacity: 0.7 }}>Powered by Claude · Contexto do CRM ativo</div>
          </div>
        </div>
        <button onClick={limpar} style={{ background: 'rgba(255,255,255,0.1)', border: 'none', color: '#fff', borderRadius: 4, padding: '4px 12px', fontSize: 12, cursor: 'pointer', fontWeight: 600 }}>
          Limpar conversa
        </button>
      </div>

      {/* Mensagens */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '14px 16px', display: 'flex', flexDirection: 'column', gap: 12, background: '#f8fafc' }}>
        {mensagens.map((m, i) => (
          <div key={i} style={{ display: 'flex', justifyContent: m.role === 'user' ? 'flex-end' : 'flex-start' }}>
            {m.role === 'assistant' && (
              <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'linear-gradient(135deg,#3b82f6,#8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, flexShrink: 0, marginRight: 6, marginTop: 2 }}>✨</div>
            )}
            <div style={{
              maxWidth: '75%',
              background: m.role === 'user' ? '#0a1628' : '#fff',
              color: m.role === 'user' ? '#fff' : '#1f2937',
              borderRadius: m.role === 'user' ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
              padding: '8px 12px',
              fontSize: 13,
              lineHeight: 1.6,
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              border: m.role === 'assistant' ? '1px solid #e8eaed' : 'none',
            }}>
              {m.content}
            </div>
          </div>
        ))}

        {carregando && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ width: 26, height: 26, borderRadius: '50%', background: 'linear-gradient(135deg,#3b82f6,#8b5cf6)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12 }}>✨</div>
            <div style={{ background: '#fff', borderRadius: '14px 14px 14px 4px', padding: '8px 12px', border: '1px solid #e8eaed', display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ display: 'flex', gap: 3, alignItems: 'center' }}>
                {[0,1,2].map(j => (
                  <div key={j} style={{ width: 6, height: 6, borderRadius: '50%', background: '#3b82f6', animation: `bounce 1s ${j * 0.2}s infinite` }} />
                ))}
              </div>
              {progresso && <span style={{ fontSize: 12, color: '#6b7280' }}>{progresso}</span>}
            </div>
          </div>
        )}

        {mensagens.length === 1 && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 6 }}>
            {sugestoes.map((s, i) => (
              <button key={i} onClick={() => enviar(s)} style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 14, padding: '5px 12px', fontSize: 12, cursor: 'pointer', color: '#374151', fontWeight: 500 }}>
                {s}
              </button>
            ))}
          </div>
        )}

        <div ref={fimRef} />
      </div>

      {/* Input */}
      <div style={{ background: '#fff', borderTop: '1px solid #e8eaed', padding: '10px 16px', flexShrink: 0 }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', background: '#f3f4f6', borderRadius: 10, padding: '7px 10px' }}>
          <textarea
            ref={inputRef}
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); enviar(); } }}
            placeholder="Digite sua mensagem... (Enter para enviar, Shift+Enter para nova linha)"
            rows={1}
            style={{ flex: 1, border: 'none', background: 'transparent', resize: 'none', fontSize: 13, outline: 'none', fontFamily: 'inherit', lineHeight: 1.5, maxHeight: 100, overflowY: 'auto' }}
          />
          <button onClick={() => enviar()} disabled={!input.trim() || carregando}
            style={{ background: input.trim() && !carregando ? '#0a1628' : '#d1d5db', color: '#fff', border: 'none', borderRadius: 6, width: 32, height: 32, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: input.trim() && !carregando ? 'pointer' : 'default', flexShrink: 0, fontSize: 14, transition: 'background 0.2s' }}>
            ➤
          </button>
        </div>
        <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 4, textAlign: 'center' }}>
          A Clau tem acesso ao CRM em tempo real · Não compartilha dados fora do sistema
        </div>
      </div>

      <style>{`@keyframes bounce { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-4px)} }`}</style>
    </div>
  );
};

export default Assistente;
